module.exports = __webpack_public_path__ + "assets/img/Amaze-Wholesale-1-Landing-Page.1cc9c7ad.webp";